define([
	'internal_util/UiUtil',
	'factory/ProviderInfoFactory',
	'factory/AuthenticationOptionsFactory',
	'factory/AuthenticationOptionGroupsFactory',
	'factory/RequestedAttributesFactory',
	'lib/jquery'
], function (
		UiUtil,
		ProviderInfoFactory,
		AuthenticationOptionsFactory,
		AuthenticationOptionGroupsFactory,
		RequestedAttributesFactory,
		jQuery
		) {
	'use strict';

	// private methods


	// public methods

	/**
	 * Parse the given options.
	 * @param {string} options Options (aka SP metadata or SAML EntityDescriptor) as raw XML string.
	 * @returns {Object} Parsed options: Object of the form 
	 * {
	 *   providerInfo: providerInfo,
	 *   authenticationOptions: authenticationOptions,
	 *   requestedAttributes: requestedAttributes
	 * }
	 */
	function parseOptions(options) {
		var providerInfo,
				authenticationOptions,
				authenticationOptionGroups,
				authenticationOptionsOrGroups,
				requestedAttributes,
				result;

		options = jQuery(options);

		providerInfo = ProviderInfoFactory.create(options);

		authenticationOptions = AuthenticationOptionsFactory.create(options);
		authenticationOptionGroups = AuthenticationOptionGroupsFactory.create(options, authenticationOptions);
                
//                console.groupCollapsed("== authenticationOptions ==");
                for (var i in authenticationOptions) {
//                    console.info(authenticationOptions[i].id());
//                    console.groupCollapsed("== requestedAttributes == "+"("+authenticationOptions[i].id()+")");
                    for (var j in authenticationOptions[i].requestedAttributes()) {
//                        console.info(authenticationOptions[i].requestedAttributes()[j].name());
//                        console.info(authenticationOptions[i].requestedAttributes()[j].origin());
                    }
//                    console.groupEnd();
                }
//                console.groupEnd();
//                console.info("authenticationOptionGroups ==> ",authenticationOptionGroups);

		// use options if no groups, otherwise use only groups
		if (authenticationOptionGroups.length === 0) {
			authenticationOptionsOrGroups = authenticationOptions;
		} else {
			authenticationOptionsOrGroups = authenticationOptionGroups;
		}

		// resolve (i.e. fix) origins in requested attributes of authenticationOptionsOrGroups
		RequestedAttributesFactory.resolveOrigins(authenticationOptionsOrGroups);

		// global requested attributes (options may contain option specific requested attributes)
		requestedAttributes = RequestedAttributesFactory.create(options);

		result = {
			providerInfo: providerInfo,
			authenticationOptions: authenticationOptionsOrGroups,
			requestedAttributes: requestedAttributes
		};
                
//                console.info(" << = parseOptions = >>");
//                console.groupCollapsed("authenticationOptions");
//                for (var d in result.authenticationOptions) {
//                    console.info(result.authenticationOptions[d].id());
//                }
//                console.groupEnd();

		return result;
	}

	function loadImages(parsedOptions, callbacks, errorCallbacks) {
		var images = new Array(),
				i;

		images.push(parsedOptions['providerInfo'].image());

		for (i = 0; i < parsedOptions['authenticationOptions'].length; i++) {
			if (parsedOptions['authenticationOptions'][i].image() !== null) {
				images.push(parsedOptions['authenticationOptions'][i].image());
			}
		}

		UiUtil.preloadImages(images, callbacks, errorCallbacks);
	}

	return {
		parseOptions: parseOptions,
		loadImages: loadImages
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/OptionsUtil.js
// module id = 140
// module chunks = 6